<template lang="pug">
v-container.grid-list-xl
  v-layout(row wrap)
    v-flex(lg12 sm12 xs12)
      //- my-trips-search
      v-btn(depressed color="primary" class="mb-3" @click="goToNew" :disabled="hasTravelActive")
        v-icon(v-text="'add'")
        span(v-text="'Nova Viagem'")
      my-trips-table
</template>

<script>
// import MyTripsSearch from './index/search'
import MyTripsTable from "./index/table";
import viagensService from "@/services/viagens.service";
import { ViagemStore } from "@/store/modules/viagens";
import { mapState, mapActions } from "vuex";

export default {
  name: "MyTrips",

  components: {
    // MyTripsSearch,
    MyTripsTable,
  },

  data: () => ({}),
  computed: {
    ...mapState("viagens", ["hasTravelActive"]),
  },
  mounted() {
    this.verify();
  },
  methods: {
    goToNew() {
      this.$router.push({ name: "my-trips-new" });
    },
    ...mapActions("viagens", { verify: "VERIFY" }),
  },
};
</script>
